export const AllowedDomainsAndAttributeMappingAzureActiveDirectory = '/admin-guide/setting-up-the-azure-ad-integration';

export const AzureADIntegrationLink = '/admin-guide/setting-up-the-azure-ad-integration';
